export default {
  title: 'Informations commerciales',
  form: {},
  buttons: {
    save: 'Enregistrer',
  },
  toasts: {
    success: 'Vos informations ont été enregistrées avec succès.',
  },
};
